module.exports = __webpack_public_path__ + "img/line.5456d42b.svg";